import { useMemo, useState, useLayoutEffect } from 'react';
import { isTrueMobile } from '../utils/isTrueMobile';
// import { useAppStore } from '../../store/app/appStore';

/**
 * Hook that provides reliable mobile detection combining user agent and store settings
 * Returns true if device is mobile based on user agent OR store mode setting
 * Automatically updates on window resize/orientation change with debouncing
 */
export const useTrueMobile = () => {
  // const isMobile = useAppStore((state) => state.settings.mode === 'mobile');
  const [updateTrigger, setUpdateTrigger] = useState(0);

  useLayoutEffect(() => {
    const handleResize = () => {
      setUpdateTrigger(prev => prev + 1);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);
  
  return useMemo(() => isTrueMobile(), [updateTrigger]);
};
